import type { GlossaryItem } from '@features/glossary';
import type { TextProps, TextPropsTextConfig } from '@features/powerpoint';
import { ZERO_WIDTH_SPACE } from '@features/powerpoint';
import { definitionTextV2 } from '../components/definition-text-v2';

const compactBlankLine: TextPropsTextConfig = {
  text: ZERO_WIDTH_SPACE,
  options: {
    breakLine: true,
    fontSize: 4,
    paraSpaceAfter: 0,
    paraSpaceBefore: 0,
  },
};

export const getDefinitionsV2 = (
  glossaryEntries: GlossaryItem[],
  column: number,
  runningTotal: number[]
): TextProps => {
  return {
    text: glossaryEntries
      .slice(runningTotal[column - 1] ?? 0, runningTotal[column])
      .flatMap(({ label, definition, subItems }): TextPropsTextConfig[] => [
        ...definitionTextV2(label, definition),
        ...(subItems
          ? Object.values(subItems).flatMap((subItem): TextPropsTextConfig[] =>
              definitionTextV2(subItem.label, subItem.definition, {
                subItem: true,
              })
            )
          : []),
        compactBlankLine,
      ]),
  };
};
